<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2 mb-3">
                    <h2>Processed Data</h2>
                    </div>
                    <div class="col-lg-10 col-10 col-md-12 text-right">
                      <div class="input-group d-inline-flex justify-content-end">
                        <!-- <button  @click="openAddNewCusipModal()" type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSIP</button> -->
                        <!-- <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="search()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> -->
                    </div>
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-2">
                    <label>Tickets From</label>
                    <datepicker typeable v-model="from" placeholder="mm/dd/yyyy"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <label>Tickets To</label>
                    <datepicker typeable v-model="to" placeholder="mm/dd/yyyy"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <label>Cusip</label>
                    <input  v-on:keyup.enter="getProcessedData" style="height:40px" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control" type="text" placeholder="Cusip" aria-label="Search">
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <label>Filter By Trader</label>
                     <multiselect 
                        v-model="filterTrader" 
                        placeholder="Select traders" 
                        label="firstName" 
                        track-by="traderId"
                        :options="traderList"  
                        :multiple="false" 
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="search()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >Cusip</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ticketDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ticketDate'  ? 'sort-desc' : '']"  
                                    @click="sort('ticketDate')"
                                    >Date</th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >File Name</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Trader</th>    
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>                     
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="ticketData.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in ticketData" :key="data.id">
                                <td class="text-wrap">{{data.cusip.join(', ')}}</td>
                                <td class="text-center">{{data.ticketDate ? moment(data.ticketDate).format("MMMM DD YYYY") : ""}}</td>
                                <td class="text-center">
                                    {{data.filename}}
                                    <!-- <div v-if="data.filepath">
                                    <button @click="downloadFile(data.filepath)" class="btn btn-warning rounded ml-2 mt-0" type="button">
                                        <i class="fas fa-download"></i>  DOWNLOAD
                                    </button> -->
                                    <!-- </div> -->
                                </td>
                                <td class="text-center">{{data.userFirstName}} {{data.userLastName}}</td>
                                <td class="text-center">
                                  <button @click="downloadFile(data.filepath)" class="btn btn-warning rounded ml-2 mt-0" type="button">
                                    <i class="fas fa-download"></i>  DOWNLOAD
                                  </button>
                                    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- <nav aria-label="Page navigation example" v-if="!(ticketData.length == 0 && currentPage === 0)">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                    <a class="page-link cursor-pointer"   @click="previous()">
                                        <i class="fa fa-angle-left"></i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>
                                <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                <li class="page-item" v-bind:class="{ disabled: this.ticketData.length < this.perPage }"  >
                                    <a class="page-link cursor-pointer" @click="next()">
                                        <i class="fa fa-angle-right"></i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>
                            </ul>
                        </nav> -->
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getProcessedData(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "ticketDate",
        sortOrder: "DESC",
        ticketData : [],
        createdDate : new Date(),
        showFilters : false,
        filterTrader : null,
        traderList : [],
     
    };
  },
  methods: {
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getProcessedData();
    },
    getTraderList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
            auth
        )
        .then(result => {
          this.traderList = result.data.content;
        })
        .catch(e => {
          console.log(e);
        });
    },
    search(){
        this.currentPage = 1;
        this.getProcessedData();  
    },
    clearFilter(){
      this.searchValue = "";
      this.from = "";
      this.to = "";
      this.filterTrader = [];
      this.getProcessedData();
    },
    downloadFile(downloadKey){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 0;
        this.filterTrader = ""
        this.getProcessedData();  
    },
    next(){
        if(this.ticketData.length === this.perPage){
            this.currentPage++;
            this.getProcessedData(); 
        }
        
    },
    previous(){
        if(this.currentPage > 0){
            this.currentPage--;
            this.getProcessedData(); 
        }
        
    },
    getProcessedData(){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/ticket-catalogue/list"+
          "?page="+this.currentPage+
          "&size="+this.perPage+
          "&search="+this.searchValue+
          "&sortOrder="+this.sortOrder+           
          "&from="+(this.from ? this.moment(this.from).format("YYYY-MM-DD") : "")+
          "&to="+(this.to ? this.moment(this.to).format("YYYY-MM-DD") : "")+
          "&cognitoSub=" +
          (this.filterTrader ? this.filterTrader.cognitoSub : "")+
          "&timezone="+this.moment().utcOffset(),
          auth
        )
        .then((result) => {
            this.ticketData = result.data.content;
            this.totalRows = result.data.pageInfo.totalElements;
            this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    }
   
  },
  mounted() {
    this.from = new Date();
    this.to = new Date();
    this.getTraderList();
    this.getProcessedData();
    //console.log("rfr",this.moment().utcOffset())
  }
};
</script>